import { Action } from '@ngrx/store';
import { DepotLocation } from '@shared/models/depot-location.enum';
import { CarHireDepotSearchResultResponse } from '@shared/shared/interfaces/travel-car-hire.interfaces';

export const GET_CAR_HIRE_DETAILS = '[Car Hire Details] Get car hire details';
export const GET_CAR_HIRE_DETAILS_SUCCESS = '[Car Hire Details] Get car hire details success';
export const GET_CAR_HIRE_DETAILS_FAILURE = '[Car Hire Details] Get car hire details failure';

export class GetCarHireDetails implements Action {
  readonly type = GET_CAR_HIRE_DETAILS;
  constructor(public payload: { dropOffId: number; pickUpId: number }) {}
}

export class GetCarHireDetailsSuccess implements Action {
  readonly type = GET_CAR_HIRE_DETAILS_SUCCESS;
  constructor(public payload: { depot: DepotLocation; data: CarHireDepotSearchResultResponse }) {}
}

export class GetCarHireDetailsFailure implements Action {
  readonly type = GET_CAR_HIRE_DETAILS_FAILURE;
  constructor(public payload: any) {}
}

export type CarHireDetailsActions = GetCarHireDetails | GetCarHireDetailsSuccess | GetCarHireDetailsFailure;
